import { z } from 'zod';

export const phoneNumberSchema = z
  .string()
  .transform((val) => val.replace(/^\+/, '')) // Remove leading + if present
  .refine((val) => val.replace(/\D/g, '').length >= 10, {
    message: 'Phone number must have at least 10 digits',
  });

export const teamMemberSchema = z.object({
  firstName: z
    .string()
    .min(1, 'First name is required')
    .regex(/^[a-zA-Z\s]+$/, 'First name must contain only letters and spaces')
    .transform((val) => val.trim().replace(/\s+/g, ' ')), // Trim and normalize spaces
  lastName: z
    .string()
    .regex(/^[a-zA-Z\s]*$/, 'Last name must contain only letters and spaces')
    .transform((val) => val.trim().replace(/\s+/g, ' ')) // Trim and normalize spaces
    .optional(),
  email: z.string().email('Invalid email address').min(1, 'Email is required'),
  phoneNumber: phoneNumberSchema,
  bio: z.string().optional(),
  slug: z
    .string()
    .regex(/^[a-z0-9-]*$/, 'Slug must contain only lowercase letters, numbers, and hyphens')
    .transform((val) => val.trim().toLowerCase())
    .optional(),
  photoUrl: z
    .union([
      z.string().url('Invalid URL format'),
      z.string().length(0), // Allow empty string
    ])
    .optional(),
});

export type TeamMemberInput = z.infer<typeof teamMemberSchema>;
